/** @jsx jsx */
import { css } from '@emotion/core';

export const slideShowStyle = {
  thumbBlock: css`
    cursor: pointer;
    position: relative;
    &:before {
      content: "";
      display: block;
      padding-top: 66.666%;
    }
    & > div {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      & > div {
        width: 100%;
        height: 100%;
      }
    }
  `,
  block: css`
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
  `,
  sliderWrapper: css`
    width: 100%;
    height: 100%;
  `,
  close: css`
    display: block;
    position: absolute;
    z-index: 100;
    top: 0.375rem;
    left: 0.5rem;
    cursor: pointer;
    padding: 0;
    width: 3rem;
    height: 3rem;
    span {
      width: 2rem;
      height: 0.125rem;
      position: absolute;
      top: 50%;
      left: 50%;
      background: #000;
      &:first-of-type{
        transform: translate(-50%, -50%) rotate(45deg);
      }
      &:last-of-type{
        transform: translate(-50%, -50%) rotate(-45deg);
      }
    }
  `,
}
